export const YOUTUBE_PRIMARY_COLOR = `#FF0000`
